// extracted by mini-css-extract-plugin
export default {"footer":"DeleteTask_footer__An1Gd"};